/* Babbez — scroll reveal (fail-safe: no JS => nothing hidden) */
(function () {
  var els = document.querySelectorAll('[data-bz]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  for (var i = 0; i < els.length; i++) els[i].classList.add('bz-anim');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px 18% 0px', threshold: 0.01 });
  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();
